import Switch from 'react-switch';

interface AlertNotificationSwitchProps {
  alertId: string;
  type: 'email' | 'sms';
  checked: boolean;
  onChange: (alertId: string, type: 'email' | 'sms') => void;
  disabled?: boolean;
}

const AlertNotificationSwitch: React.FC<AlertNotificationSwitchProps> = ({
  alertId,
  type,
  checked,
  onChange,
  disabled = false,
}) => {
  const label = `${
    type === 'email' ? 'Email' : 'SMS'
  } notifications for alert ${alertId}`;

  const handleClick = () => {
    if (disabled) {
      onChange(alertId, type);
    }
  };

  return (
    <div
      className={`flex items-center cursor-pointer ${disabled ? 'opacity-50' : ''}`}
      onClick={handleClick}
    >
      <Switch
        aria-label={label}
        data-testid="alert-switch"
        aria-hidden="true"
        aria-checked={checked}
        checked={checked}
        onChange={() => !disabled && onChange(alertId, type)}
        offColor="#D1D5DB"
        onColor="#4CAF50"
        offHandleColor="#FFFFFF"
        onHandleColor="#FFFFFF"
        height={24}
        width={48}
        uncheckedIcon={false}
        checkedIcon={false}
        disabled={disabled}
        tabIndex={0}
        role="switch"
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onChange(alertId, type);
          }
        }}
      />
    </div>
  );
};

export default AlertNotificationSwitch;
